
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/prohyp/register",
      function () {
        return require("private-next-pages/[lang]/prohyp/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/prohyp/register"])
      });
    }
  